import { IndexTable, Text } from '@shopify/polaris';
import { useEffect, useState } from 'react';

const SellAddStockTable = ({ product, sell, onAddQty }) => {
  const headings = [{ title: '' }, ...product.variants.map((v) => ({ title: v.title })), { title: 'TOTAL' }] || [];
  const [sold, setSold] = useState(initialSold(product));

  useEffect(() => {
    const qtys = product.variants
      .map(({ barcode }) => ({
        barcode,
        qty: sold.find((d) => d.barcode === barcode)?.qty ?? 0,
      }))
      .filter(({ qty }) => qty !== 0);

    onAddQty(qtys);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, sold]);

  return (
    <IndexTable headings={headings} itemCount={2} selectable={false} lastColumnSticky={true}>
      <QtyDepositOriginStockRow deposit={sell.deposit} product={product} sold={sold} />
      <QtyInputStockRow product={product} sold={sold} setSold={setSold} />
    </IndexTable>
  );
};

const initialSold = (product) =>
  product.variants.map(({ barcode }) => {
    return {
      qty: 0,
      barcode,
    };
  });

const QtyDepositOriginStockRow = ({ deposit, product, sold }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          {deposit.name}
        </Text>
      </IndexTable.Cell>
      {stockAtDeposit(product, deposit).map((s, i) => (
        <IndexTable.Cell key={i}>
          <Text alignment="center" variant="headingXs" fontWeight="regular">
            {s.qty}{' '}
            {sold.find((t) => t.barcode === s.barcode).qty > 0
              ? ' -> ' + (s.qty - sold.find((t) => t.barcode === s.barcode).qty)
              : ''}
          </Text>
        </IndexTable.Cell>
      ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {stockAtDeposit(product, deposit).reduce((acc, cur) => acc + cur.qty, 0)}{' '}
          {sold.reduce((acc, cur) => acc + cur.qty, 0)
            ? ' -> ' +
              (stockAtDeposit(product, deposit).reduce((acc, cur) => acc + cur.qty, 0) -
                sold.reduce((acc, cur) => acc + cur.qty, 0))
            : ''}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const QtyInputStockRow = ({ product, sold, setSold }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          TRANSFERENCIA
        </Text>
      </IndexTable.Cell>
      {product.variants
        .map((v) => sold.find((d) => d.barcode === v.barcode))
        .map((d, i) => (
          <IndexTable.Cell key={i}>
            <input
              type="number"
              value={d.qty}
              style={{ width: '40px', borderBottom: '1px solid black', textAlign: 'center' }}
              onChange={(e) =>
                setSold([
                  ...sold.filter((ps) => ps.barcode !== d.barcode),
                  {
                    barcode: d.barcode,
                    qty: e.target.value ? parseInt(e.target.value) : 0,
                  },
                ])
              }
            />
          </IndexTable.Cell>
        ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {sold.reduce((acc, cur) => acc + cur.qty, 0)}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const stockAtDeposit = (product, deposit) =>
  product.variants.map((v) => {
    const s = product.stock.find((s) => v.barcode === s.barcode && s.deposit.id === deposit.id);
    return {
      qty: s ? s.qty : 0,
      barcode: v.barcode,
    };
  });

export default SellAddStockTable;
